<!--<script src="https://amazon-cognito-assets.eu-west-1.amazoncognito.com/amazon-cognito-advanced-security-data.min.js" *ngIf="isMFA"></script>-->
<central-login-header [platform]="currentPlatform"></central-login-header>

<div class="content" *ngIf="invalidPlatform">
    <h3 class="form-title">{{'central-login.login.to.your.account' | translate }}</h3>
    <div class="alert alert-danger mt-3 p-2" [innerHTML]="'central-login.platform.invalid' | translate"></div>
</div>
<div class="content" *ngIf="renderLoginForm">
    <form [formGroup]="loginFormFirstStep" (ngSubmit)="continue()" *ngIf="!emailGiven">
        <h3 class="form-title">{{'central-login.login.to.your.account' | translate }}</h3>
        <div class="alert alert-danger mt-3 p-2" *ngIf="emailErrorNotExisting || emailErrorNotActive || emailErrorNotVerified || emailError" [innerHTML]="emailErrorMessage"></div>
        <div class="alert alert-danger mt-3 p-2" *ngIf="loginFailure">{{ 'central-login.failure' | translate }}</div>
        <div class="form-group">
            <label class="form-control-label">{{'central-login.email' | translate }}
                <input id="email" type="text" formControlName="email" class="form-control" [ngClass]="{ 'is-invalid': firstFormSubmitted && formFirstStep.email.errors }" />
            </label>
            <div *ngIf="firstFormSubmitted && formFirstStep.email.errors" >
                <div class="alert alert-danger mt-3 p-2" *ngIf="formFirstStep.email.errors.required">{{ 'central-login.email.required' | translate }}</div>
                <div class="alert alert-danger mt-3 p-2" *ngIf="formFirstStep.email.errors.email">{{ 'central-login.email.not.valid' | translate }}</div>
            </div>
        </div>
        <div class="row login-form__actions" *ngIf="currentPlatform">
            <div class="col-md-12 text-left" >
                <p><a class="u-cursor--pointer text-white" (click)="goToContactAdmin()" ><i class="fa fa-envelope-o"></i> {{'central-login.admin.contact' | translate }}</a></p>
            </div>
        </div>
        <div class="row mt-3">
            <div class="col-md-12">
                <button class="btn psd-variant w-100" type="submit" >{{'central-login.next' | translate }}</button>
            </div>
        </div>
    </form>
    <form [formGroup]="loginFormSecondStep" (ngSubmit)="login()" *ngIf="emailGiven && !isMFA">
        <h3 class="form-title">{{'central-login.login.to.your.account' | translate }}</h3>
        <div class="alert alert-danger mt-3 p-2" *ngIf="loginFailure">{{ 'central-login.failure' | translate }}</div>
        <div class="text-white mb-3">{{formSecondStep['email'].value}} (<span class="u-cursor--pointer" (click)="resetEmail()">{{ 'central-login.email.change' | translate }}</span>)</div>
        <div class="form-group">
            <label class="form-control-label">{{'central-login.password' | translate }}
                <input id="password" type="password" formControlName="password" class="form-control d-inline-block" [ngClass]="{ 'is-invalid': submitted && formSecondStep.password.errors }" />
                <i class="fa fa-eye d-inline-block" id="togglePassword" (click)="togglePassword($event)" style="margin-left: -30px; cursor: pointer;"></i>
                <div *ngIf="submitted && formSecondStep.password.errors" >
                    <div class="alert alert-danger mt-3 p-2" *ngIf="formSecondStep.password.errors.required">{{ 'central-login.password.required' | translate }}</div>
                </div>
            </label>
        </div>
        <div class="row login-form__actions">
            <div class="col-md-12 text-left">
                <p><a class="u-cursor--pointer text-white" (click)="goToForgotPassword()" ><i class="fa fa-question-circle-o"></i> {{'central-login.password.lost' | translate }}</a></p>
            </div>
        </div>

        <div class="row login-form__actions" *ngIf="currentPlatform">
            <div class="col-md-12 text-left" >
                <p><a class="u-cursor--pointer text-white" (click)="goToContactAdmin()" ><i class="fa fa-envelope-o"></i> {{'central-login.admin.contact' | translate }}</a></p>
            </div>
        </div>

        <div class="row mt-3">
            <div class="col-md-12">
                <button class="btn psd-variant w-100" type="submit" [disabled]="submitting" >{{'central-login.login' | translate }}</button>
            </div>
        </div>
    </form>

    <form [formGroup]="loginFormMFAStep" (ngSubmit)="submitMFA()" *ngIf="emailGiven && isMFA">
        <h3 class="form-title">{{'central-login.login.to.your.account' | translate }}</h3>
        <div class="alert alert-danger mt-3 p-2" *ngIf="loginFailure">{{ 'central-login.failure' | translate }}</div>
        <div class="text-white mb-3">{{formSecondStep['email'].value}}</div>
        <div class="form-group">
            <label class="form-control-label">{{'central-login.mfa.token' | translate }}
                <input type="text" formControlName="code" class="form-control" [ngClass]="{ 'is-invalid': mfaFormSubmitted && formMFAStep.code.errors }" />
            </label>
            <div *ngIf="mfaFormSubmitted && formMFAStep.code.errors" >
                <div class="alert alert-danger mt-3 p-2" *ngIf="formMFAStep.code.errors.required">{{ 'central-login.mfa.token.required' | translate }}</div>
            </div>
        </div>
        <div class="row mt-3">
            <div class="col-md-12">
                <button class="btn psd-variant w-100" type="submit" [disabled]="submittingMFA" >{{'central-login.login' | translate }}</button>
            </div>
        </div>
    </form>
</div>
<central-login-footer></central-login-footer>
<central-login-background-slider [platform]="currentPlatform"></central-login-background-slider>
<form id="goToPlatformForm" action="" method="post">
    <input type="hidden" name="central_access_token" value="">
    <input type="hidden" name="central_refresh_token" value="">
    <input type="hidden" name="refresh_token" value="">
    <input type="hidden" name="access_token" value="">
    <input type="hidden" name="expires_in" value="">
    <input type="hidden" name="force_token_refresh" value="false">
    <input type="hidden" name="q" value="">
</form>
